import { z } from 'zod';
export const insuranceClaimsRelationshipPartiesCapability = 'relationships.insurance-claim-parties.v1';
export const insuranceClaimsRelationshipPartiesSlot = 'insurance-claims.relationship-parties';
export const insuranceClaimsRelationshipPartiesProviderId = 'relationships.server.insurance-claims-parties';
const idSchema = z.string().uuid();
export const insuranceClaimsRelationshipPartiesProviderRequestSchema = z.strictObject({
    consumerModuleId: z.literal('insurance-claims'),
    requestedCapability: z.literal(insuranceClaimsRelationshipPartiesCapability),
    resourceType: z.literal('insurance-claims.claim'),
    resourceId: idSchema,
    projectId: idSchema,
    carrierOrganizationId: idSchema.nullable(),
    adjusterContactId: idSchema.nullable(),
});
export const insuranceClaimsRelationshipCarrierPartySchema = z.discriminatedUnion('state', [
    z.strictObject({ state: z.literal('not-linked') }),
    z.strictObject({ state: z.literal('missing'), organizationId: idSchema }),
    z.strictObject({
        state: z.literal('present'),
        organizationId: idSchema,
        displayName: z.string().trim().min(1).max(240),
        type: z.enum(['customer', 'insurance', 'vendor', 'adjuster', 'property_manager', 'other']),
        status: z.enum(['active', 'difficult', 'preferred', 'inactive']),
        updatedAt: z.string().datetime({ offset: true }),
    }),
]);
export const insuranceClaimsRelationshipAdjusterPartySchema = z.discriminatedUnion('state', [
    z.strictObject({ state: z.literal('not-linked') }),
    z.strictObject({ state: z.literal('missing'), contactId: idSchema }),
    z.strictObject({
        state: z.literal('present'),
        contactId: idSchema,
        displayName: z.string().trim().min(1).max(241),
        type: z.enum(['customer', 'adjuster', 'agent', 'property_manager', 'vendor', 'internal', 'other']),
        status: z.enum(['active', 'difficult', 'vip', 'inactive']),
        organizationId: idSchema.nullable(),
        updatedAt: z.string().datetime({ offset: true }),
    }),
]);
export const insuranceClaimsRelationshipPartiesProviderResponseSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(insuranceClaimsRelationshipPartiesCapability),
    projectId: idSchema,
    carrier: insuranceClaimsRelationshipCarrierPartySchema,
    adjuster: insuranceClaimsRelationshipAdjusterPartySchema,
    contentHash: z.string().regex(/^[a-f0-9]{64}$/),
    observedAt: z.string().datetime({ offset: true }).nullable(),
});
export const insuranceClaimsRelationshipPartiesUnavailableReasonSchema = z.enum([
    'not-installed',
    'not-enabled',
    'permission-denied',
    'party-links-not-present',
    'provider-invalid',
    'provider-failed',
]);
export const insuranceClaimsRelationshipPartiesAvailabilitySchema = z.discriminatedUnion('state', [
    insuranceClaimsRelationshipPartiesProviderResponseSchema,
    z.strictObject({
        state: z.literal('unavailable'),
        capability: z.literal(insuranceClaimsRelationshipPartiesCapability),
        reasonCode: insuranceClaimsRelationshipPartiesUnavailableReasonSchema,
    }),
]);
//# sourceMappingURL=insurance-claims-relationship-parties.contract.js.map